/** Consulta assistida de CNPJ (EMP-02): não grava cadastro nem determina papéis. */
import { z } from 'zod'
import { documento } from './cadastro.js'
import { endereco } from './entidades.js'
import { uuid } from './comum.js'

/** A máscara pode sair; as letras do CNPJ alfanumérico permanecem. DV é validado no servidor. */
export const cnpjDaConsulta = z.string().max(32)
  .transform((valor) => valor.replace(/[\s./-]/g, '').toUpperCase())
  .pipe(documento.regex(/^[A-Z0-9]{12}[0-9]{2}$/, 'Informe os 14 caracteres do CNPJ.'))

export const dadosDeCnpj = z.object({
  cnpj: cnpjDaConsulta,
  razaoSocial: z.string().nullable(),
  nomeFantasia: z.string().nullable(),
  inscricaoEstadual: z.string().nullable(),
  inscricaoMunicipal: z.string().nullable(),
  endereco,
})
export type DadosDeCnpj = z.infer<typeof dadosDeCnpj>

/** Falha externa, ausência e resposta incompleta são estados diferentes; manual continua livre. */
export const respostaDeCnpj = z.discriminatedUnion('estado', [
  z.object({ estado: z.literal('encontrado'), dados: dadosDeCnpj }),
  z.object({ estado: z.literal('incompleto'), dados: dadosDeCnpj }),
  z.object({ estado: z.literal('ja_cadastrada'), empresa: z.object({ id: uuid, nome: z.string() }) }),
  z.object({ estado: z.literal('nao_encontrado') }),
  z.object({
    estado: z.literal('limite'),
    origem: z.enum(['local', 'provedor']),
    tenteNovamenteEmSegundos: z.number().int().min(1).max(3600),
  }),
  z.object({ estado: z.literal('tempo_esgotado') }),
  z.object({
    estado: z.literal('indisponivel'),
    motivo: z.enum(['provedor', 'rede', 'resposta_invalida', 'nao_suportado']),
  }),
])
export type RespostaDeCnpj = z.infer<typeof respostaDeCnpj>
